export const LOGO = require("../assets/images/logo.jpg");
export const girl = require("../assets/images/girl.png");
export const paypal = require("../assets/images/paypal.png");
export const creditCard = require("../assets/images/credit_card.jpg");
